import { ArrowUp, SmallIcon } from "@nova/component-icons"
import { useTranslation } from "@nova/use-translation"
import classNames from "classnames"
import { animationClass } from "features/data-management/workspace/constants"
import { useCallback } from "react"
import { ContentSortDirection, ContentSortMode } from "@nova/constants"
import { useLocalStorageValue, setLocalStorageValue } from "tools/store/localStorageRegistry"

export const SortableHeader = ({
    title,
    sortMode,
    className,
}: {
    title: string
    sortMode: ContentSortMode
    className?: string
}) => {
    const { t } = useTranslation()

    const selectedSortMode = useLocalStorageValue("workspace-content-sort-mode")
    const selectedSortDirection = useLocalStorageValue("workspace-content-sort-dir")
    const isSortingByThisColumn = sortMode === selectedSortMode

    const handleClick = useCallback(() => {
        if (isSortingByThisColumn) {
            setLocalStorageValue(
                "workspace-content-sort-dir",
                selectedSortDirection === ContentSortDirection.Ascending
                    ? ContentSortDirection.Descending
                    : ContentSortDirection.Ascending
            )
            return
        }

        setLocalStorageValue("workspace-content-sort-mode", sortMode)
    }, [isSortingByThisColumn, selectedSortDirection, sortMode])

    return (
        <div
            className={classNames(
                animationClass,
                "flex gap-1 items-center cursor-pointer select-none",
                className,
                {
                    "text-gray-100": isSortingByThisColumn,
                }
            )}
            onClick={handleClick}
        >
            <small className="xs">{t(title)}</small>
            {isSortingByThisColumn && (
                <SmallIcon
                    Icon={ArrowUp}
                    className={classNames(animationClass, {
                        "rotate-180": selectedSortDirection === ContentSortDirection.Descending,
                    })}
                />
            )}
        </div>
    )
}
